<svg
  aria-labelledby="download-icon-title download-icon-desc"
  width="22px"
  height="18px"
  viewBox="0 0 22 18"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  aria-labelledby="download-icon-title download-icon-desc"
  role="img"
>
  <!-- Generator: sketchtool 63.1 (101010) - https://sketch.com -->
  <title id="download-icon-title">Download icon</title>
  <desc id="download-icon-desc">This is a download icon.</desc>
  <g
    id="Page-1"
    stroke="none"
    stroke-width="1"
    fill="none"
    fill-rule="evenodd"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <g
      id="Application-events"
      transform="translate(-1143.000000, -183.000000)"
      stroke="#26478D"
      class="stroke"
    >
      <g
        id="Download-Toggle"
        transform="translate(893.000000, 175.000000)"
      >
        <g
          id="download-btn"
          transform="translate(236.000000, 0.000000)"
        >
          <g
            id="main_icn_Download_02"
            transform="translate(15.000000, 9.000000)"
          >
            <path
              d="M20,10.5263158 L20,13.1578947 C20,14.6052632 18.8157895,15.7894737 17.3684211,15.7894737 L2.63157895,15.7894737 C1.18421053,15.7894737 0,14.6052632 0,13.1578947 L0,10.5263158"
              id="Shape"
            ></path>
            <line
              x1="10"
              y1="0"
              x2="10"
              y2="12.6315789"
              id="Shape"
            ></line>
            <polyline
              id="Shape"
              points="13.4210526 8.94736842 10 12.6315789 6.57894737 8.94736842"
            ></polyline>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
